
import axios from "axios";
import BaseValues from "./BaseValues";


export const getAllBusRoutes = () => {
    
    const data = BaseValues.createFormData({
        mode: "BUS"
	});

    const url = `${BaseValues.BaseURL}/api/busDV/getBusRoutes`;

    var config = {
        url,
        data,
        method: "POST",
        timeout: 2000
    }

    return axios(config);
}

export const getVehicleLocations = (params) => {

    const data = BaseValues.createFormData({
		lat: params.lat,
		lon: params.lng,
		radius: Math.floor(params.radius),
		mode: "BUS"
	}, true);

	const url = `${BaseValues.BaseURL}/api/busDV/getVehicleLocations`;

    var config = {
        method: 'post',
		url,
		data,
		timeout: 2000
    };

    return axios(config);
};

export const getStopAndTerminalLocations = (params) => {

    const data = BaseValues.createFormData({
		lat: params.lat,
		lon: params.lng,
		radius: Math.floor(params.radius),
		direction: null,
		route: null,
		mode: "BUS"
	}, true);

	const url = `${BaseValues.BaseURL}/api/busDV/getBusLocationsData`;

    var config = {
        method: 'post',
		url,
		data,
		timeout: 7000
    };

    return axios(config);
}

